// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Input_inputWrapper__NqixI","input":"Input_input__Vnl8Q","label":"Input_label__7H1CW","required":"Input_required__IJoP5","fileInput":"Input_fileInput__UEux7"};